export const IMAGES = {
  heroTruck: "https://images.unsplash.com/photo-1697847726197-bc8bd6cc6e4d?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunsetHighway: "https://images.unsplash.com/photo-1782946129556-bbdef00e64ba?crop=entropy&cs=srgb&fm=jpg&q=85",
  flatbed: "https://images.unsplash.com/photo-1756888218268-1ae95baea617?crop=entropy&cs=srgb&fm=jpg&q=85",
  heavyHaul: "https://images.unsplash.com/photo-1690176287055-6673ef2c20cc?crop=entropy&cs=srgb&fm=jpg&q=85",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85",
  cargoRacks: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85",
  calgary: "https://images.unsplash.com/photo-1628104000525-8e88995a8086?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  { id: "ftl", title: "Full Truckload (FTL)", desc: "Dedicated capacity for full loads, direct from pickup to delivery.", tag: "DEDICATED CAPACITY" },
  { id: "ltl", title: "Less-Than-Truckload (LTL)", desc: "Cost-effective shipping for smaller, palletized freight.", tag: "CONSOLIDATED FREIGHT" },
  { id: "flatbed", title: "Flatbed & Specialized", desc: "Open-deck and specialized equipment for heavy, oversized and project freight.", tag: "OVERSIZED & HEAVY HAUL" },
  { id: "reefer", title: "Temperature-Controlled", desc: "Refrigerated capacity for freight that must stay within a set temperature range.", tag: "CLIMATE-CONTROLLED" },
  { id: "cross-border", title: "Cross-Border (Canada / U.S.)", desc: "Coordinated moves between Canada and the United States with eligible carriers.", tag: "TRANSBORDER LOGISTICS" },
  { id: "project", title: "Project & Industrial Freight", desc: "Coordination for job-site, industrial and commercial project shipments.", tag: "ENERGY & INFRASTRUCTURE" },
  { id: "recurring", title: "Recurring & Contract Lanes", desc: "Consistent carriers and a single contact for your regular lanes.", tag: "SCHEDULED CONTRACTS" },
  { id: "expedited", title: "Time-Sensitive Freight", desc: "Fast sourcing of suitable capacity when your freight is urgent.", tag: "EXPEDITED DISPATCH" },
];

export const INDUSTRIES = [
  "Oil & Gas and Energy",
  "Construction & Infrastructure",
  "Manufacturing & Industrial",
  "Equipment & Machinery",
  "Wholesale & Distribution",
  "General Commercial Freight",
];

export const STEPS = [
  { step: "01", title: "Tell Us", desc: "Share your pickup, delivery, freight details and timing." },
  { step: "02", title: "We Source", desc: "We match your load with a qualified, vetted carrier." },
  { step: "03", title: "We Coordinate", desc: "Booking, pickup, tracking and communication handled." },
  { step: "04", title: "Delivered", desc: "We follow up on delivery and proof of delivery." },
];

export const MARQUEE_ITEMS = [
  "CALGARY HQ DISPATCH HUB",
  "CROSS-BORDER CANADA / U.S.",
  "FTL & LTL COORDINATION",
  "OIL & GAS / HEAVY INDUSTRIAL",
  "PROACTIVE TRACKING & UPDATES",
  "INDEPENDENT CARRIER NETWORK",
];

export const CONTACT = {
  address: "4430 112 Ave SE",
  city: "Calgary, Alberta T2C 2K2, Canada",
  location: "4430 112 Ave SE, Calgary, Alberta T2C 2K2",
  phone: "+1 (825) 454-1885",
  phoneHref: "tel:+18254541885",
  dispatch: "dispatch@eltfreightandlogistics.com",
};

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const EQUIPMENT_OPTIONS = ["Dry Van", "Flatbed", "Step Deck", "Reefer", "Specialized / Heavy Haul", "Multiple Types"];

export const AREA_OPTIONS = ["Western Canada", "Canada-Wide", "Cross-Border Canada / U.S.", "U.S. Domestic", "Northern / Remote Industrial"];
